/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { get as userGet } from 'js/lib/user';

import { typography2 } from '@coursera/cds-core';

import type { ConsumerPageHeader_EnterpriseProgramFragment as EnterpriseProgramFragment } from 'bundles/composable-page-header-consumer/queries/__generated__/ConsumerMyPageHeaderQuery';
import EnterpriseSearchBarV2, {
  UnifiedEnterpriseSearchBar,
} from 'bundles/enterprise-learner-search/components/search/EnterpriseSearchBarV2';
import { useEnterpriseProductFeatures } from 'bundles/unified-common/contexts/EnterpriseProductFeaturesContext';

type Props = {
  currentProgram?: Partial<EnterpriseProgramFragment> | null;
};

const styles = {
  searchBar: css`
    && {
      width: 100%;

      .rc-EnterpriseSearchBarV2 {
        max-width: 480px;
        min-width: 0;
        width: 100%;

        input {
          /* Needs important to override old style that's also set to important. Yuck! */
          font: ${typography2.bodySecondary.font} !important;
          letter-spacing: ${typography2.bodySecondary.letterSpacing};
        }
      }
    }
  `,
};

export function EnterpriseSearchBarLegacyGridItem(props: Props) {
  const { currentProgram } = props;
  const enterpriseProductFeatures = useEnterpriseProductFeatures();
  const userId = userGet()?.id;

  const enableSkillsInSearchAndBrowse = enterpriseProductFeatures?.enableSkillsInSearchAndBrowse;
  const shouldShowShortFormContent = enterpriseProductFeatures?.allowShortFormContentBasedOnAudience;

  const thirdPartyOrganizationSlug = currentProgram?.naptimeThirdPartyOrganization?.slug;
  const thirdPartyOrganizationId = currentProgram?.naptimeThirdPartyOrganization?.id;

  const programSlug = currentProgram?.slug;
  const programName = currentProgram?.name;
  const programId = currentProgram?.id;

  if (userId && programSlug && programName && programId && thirdPartyOrganizationId && thirdPartyOrganizationSlug) {
    return (
      <div css={styles.searchBar}>
        <UnifiedEnterpriseSearchBar
          programSlug={programSlug}
          programName={programName}
          thirdPartyOrgSlug={thirdPartyOrganizationSlug}
          thirdPartyOrganizationId={thirdPartyOrganizationId}
          userId={userId}
          programId={programId}
          enableSkillsInSearchAndBrowse={enableSkillsInSearchAndBrowse}
          shouldShowShortFormContent={shouldShowShortFormContent}
        />
      </div>
    );
  } else if (programId) {
    return (
      <div css={styles.searchBar}>
        <EnterpriseSearchBarV2
          programIds={[programId]}
          enableSkillsInSearchAndBrowse={enableSkillsInSearchAndBrowse ?? false}
          shouldShowShortFormContent={shouldShowShortFormContent}
          programName={programName}
        />
      </div>
    );
  } else {
    return null;
  }
}

export default EnterpriseSearchBarLegacyGridItem;
